export default class AddLineDropdownTemplate {
  static renderCategoryDropdown(categories, selectedCategories) {
    if (!categories.length) {
      return '<p class="text-muted">No categories available</p>'
    }

    return categories.map(category => {
      const isSelected = selectedCategories.some(id => String(id) === String(category.id))
      const count = category.count !== undefined ? ` (${category.count})` : ''

      return `
        <div class="checkbox">
          <label>
            <input type="checkbox"
                   value="${category.id}"
                   ${isSelected ? 'checked' : ''}
                   data-action="change->add-line-modal#onCategoryCheckboxChange">
            ${category.label}${count}
          </label>
        </div>
      `
    }).join('')
  }

  static renderExchangeDropdown(exchanges, selectedExchanges) {
    if (!exchanges.length) {
      return '<p class="text-muted">No exchanges available</p>'
    }

    return exchanges.map(exchange => {
      const isSelected = selectedExchanges.some(id => String(id) === String(exchange.id))
      const count = exchange.count !== undefined ? ` (${exchange.count})` : ''

      return `
        <div class="checkbox">
          <label>
            <input type="checkbox"
                   value="${exchange.id}"
                   ${isSelected ? 'checked' : ''}
                   data-action="change->add-line-modal#onExchangeCheckboxChange">
            ${exchange.label}${count}
          </label>
        </div>
      `
    }).join('')
  }

  static renderAdTypeDropdown(adTypes, selectedAdTypes) {
    const availableAdTypes = adTypes.filter(adType => adType.available !== false)

    if (!availableAdTypes.length) {
      return '<p class="text-muted">No ad types available</p>'
    }

    return availableAdTypes.map(adType => {
      const isSelected = selectedAdTypes.includes(adType.id)
      const count = adType.count !== undefined ? ` (${adType.count})` : ''

      return `
        <div class="checkbox">
          <label>
            <input type="checkbox"
                   value="${adType.id}"
                   ${isSelected ? 'checked' : ''}
                   data-action="change->add-line-modal#onAdTypeCheckboxChange">
            ${adType.label}${count}
          </label>
        </div>
      `
    }).join('')
  }

  static renderImpTypeDropdown(impTypes, selectedImpTypes) {
    if (!impTypes.length) {
      return '<p class="text-muted">No imp types available</p>'
    }

    return impTypes.map(impType => {
      const isSelected = selectedImpTypes.includes(impType.id)
      const count = impType.count !== undefined ? ` (${impType.count})` : ''

      return `
        <div class="checkbox">
          <label>
            <input type="checkbox"
                   value="${impType.id}"
                   ${isSelected ? 'checked' : ''}
                   data-action="change->add-line-modal#onImpTypeCheckboxChange">
            ${impType.label}${count}
          </label>
        </div>
      `
    }).join('')
  }

  static getDropdownButtonText(selectedItems, allItems, defaultText) {
    if (selectedItems.length === 0) {
      return defaultText
    }

    const availableItems = allItems.filter(item => item.available !== false)

    if (selectedItems.length === availableItems.length && availableItems.length > 0) {
      return 'All Selected'
    }

    if (selectedItems.length === 1) {
      const item = allItems.find(item =>
        String(item.id) === String(selectedItems[0])
      )
      return item ? item.label : defaultText
    }

    return `${selectedItems.length} selected`
  }
}
